import { create } from "zustand";
import { persist } from "zustand/middleware";

export type ExternalLinkTarget = "current-tab" | "new-tab" | "new-window";

type ExternalLinkPreferenceState = {
	target: ExternalLinkTarget;
	setTarget: (target: ExternalLinkTarget) => void;
};

export const useExternalLinkPreferenceStore =
	create<ExternalLinkPreferenceState>()(
		persist(
			(set) => ({
				target: "current-tab",
				setTarget: (target) => set({ target }),
			}),
			{ name: "external-link-preference" },
		),
	);
